import React, { Component } from "react";

export default class RadcliffNote extends Component {
  render() {
    return (
      <>
        <h6 style={{ marginBottom: 5, fontSize: 18 }}>Note:</h6>
        <br />
        <div className="d-flex bottom-instructions" style={{ marginLeft: -7 }}>
          <div className="item">
            <div className="participant-icon">ALS</div> &nbsp;&nbsp;&nbsp; = ALS
          </div>
          <div className="item">
            <div className="participant-icon">GC</div> &nbsp;&nbsp;&nbsp; =
            Asymptomatic Gene Carrier
          </div>
          <div className="item">
            <div className="participant-icon">C</div> &nbsp;&nbsp;&nbsp; =
            Controls
          </div>
        </div>
      </>
    );
  }
}
